// extracted by mini-css-extract-plugin
export var blockedMessage = "_a8-3";
export var blockedOverlay = "_a8-1";
export var fadeIn = "_a8-2";
export var hereLink = "_a8-0";
export var slideUp = "_a8-4";